import styled from 'styled-components'

export const ForgotPasswordWrapper = styled.div`
  width: 100%;
  text-align: center;
`
